/**
 * Gets the VS Code domain based on the current window location.
 * For custom domains, returns "vscode.<custom-domain>".
 * For the default domain (gitpod.io), returns "vscode.gitpod.io".
 */
export function getVSCodeDomain(): string {
    const hostname = window.location.hostname;
    
    // Check if we're on any gitpod.io domain (including subdomains like staging.gitpod.io)
    // All gitpod.io domains should use the canonical vscode.gitpod.io
    if (hostname === "gitpod.io" || hostname.endsWith(".gitpod.io")) {
        return "vscode.gitpod.io";
    }
    
    // For custom domains (non-gitpod.io domains), use vscode subdomain
    return `vscode.${hostname}`;
}

/**
 * Gets the full VS Code URL with protocol.
 */
export function getVSCodeURL(): string {
    return `https://${getVSCodeDomain()}`;
}
